import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    temp_id: 1,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/white_jacket_r8d91d.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "Wrangler",
    season: "winter",
    mrp: 6000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 2,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/red_black_jacket_jtuwct.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "Wildcraft",
    season: "winter",
    mrp: 7000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 3,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/nice_jacket_dpzmea.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "Wildcraft",
    season: "winter",
    mrp: 6500,
    discount: 50,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 4,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/green_jacket_yzjbg9.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "Nike",
    season: "winter",
    mrp: 5000,
    discount: 40,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 5,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/grey_jacket_rnzxko.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "Puma",
    season: "winter",
    mrp: 4700,
    discount: 30,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 6,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/green_blue_jacket_lmjxuz.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "zara",
    season: "winter",
    mrp: 3000,
    discount: 20,
    finalPrice: 0,
    rating:1,
  },
  {
    _id: uuid(),
    temp_id: 7,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/brown_black_jacket_zy3tlg.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "Tommy",
    season: "winter",
    mrp: 3500,
    discount: 10,
    finalPrice: 0,
    rating:1,
  },
  {
    _id: uuid(),
    temp_id: 8,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/Men%20winter%20jackets/black_yellow_jacket_v4vmuz.webp",
    gender: "men",
    name: "Full sleeve Jacket",
    brand: "Wildcraft",
    season: "winter",
    mrp: 1500,
    discount: 0,
    finalPrice: 0,
    rating:3,
  },
  {
    _id: uuid(),
    temp_id: 9,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513047/ecom%20item%20images/Men%20summer/red_tshirt_fii5ov.webp",
    gender: "men",
    name: "Men T-shirt",
    brand: "Rockhard",
    season: "summer",
    mrp: 2000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 10,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513047/ecom%20item%20images/Men%20summer/black_with_design_wkwgru.webp",
    gender: "men",
    name: "Men T-shirt",
    brand: "Polo",
    season: "summer",
    mrp: 3000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 11,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513047/ecom%20item%20images/Men%20summer/redblack_tshirt_wbiang.webp",
    gender: "men",
    name: "Men T-shirt",
    brand: "Levis",
    season: "summer",
    mrp: 4000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 12,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513047/ecom%20item%20images/Men%20summer/green_tshirt_rxudso.webp",
    gender: "men",
    name: "Men T-shirt",
    brand: "Puma",
    season: "summer",
    mrp: 800,
    discount: 40,
    finalPrice: 0,
    rating:3,
  },
  {
    _id: uuid(),
    temp_id: 13,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513047/ecom%20item%20images/Men%20summer/grey_tshirt_s4imnm.webp",
    gender: "men",
    name: "Men T-shirt",
    brand: "RedTape",
    season: "summer",
    mrp: 1500,
    discount: 30,
    finalPrice: 0,
    rating:3,
  },
  {
    _id: uuid(),
    temp_id: 14,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513047/ecom%20item%20images/Men%20summer/black_tshirt_a9gyft.webp",
    gender: "men",
    name: "Men T-shirt",
    brand: "Urban Monkey",
    season: "summer",
    mrp: 500,
    discount: 20,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 15,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513047/ecom%20item%20images/Men%20summer/black_with_cap_qovrpo.webp",
    gender: "men",
    name: "Men T-shirt",
    brand: "Being Human",
    season: "summer",
    mrp: 5000,
    discount: 10,
    finalPrice: 0,
    rating:1,
  },
  {
    _id: uuid(),
    temp_id: 16,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513050/ecom%20item%20images/women%20winter%20jackets/sky_jacket_uc4kcw.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "Wrangler",
    season: "winter",
    mrp: 6000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 17,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513050/ecom%20item%20images/women%20winter%20jackets/red_jacket_bwmk1m.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "Wildcraft",
    season: "winter",
    mrp: 7000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 18,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513050/ecom%20item%20images/women%20winter%20jackets/pink_jacket_zasbpe.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "Wildcraft",
    season: "winter",
    mrp: 6500,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 19,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513050/ecom%20item%20images/women%20winter%20jackets/purple_jacket_tornmg.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "Nike",
    season: "winter",
    mrp: 5000,
    discount: 40,
    finalPrice: 0,
    rating:3,
  },
  {
    _id: uuid(),
    temp_id: 20,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20winter%20jackets/green_jacket_edkp9e.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "Puma",
    season: "winter",
    mrp: 4700,
    discount: 30,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 21,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20winter%20jackets/denim_jacket_m26muo.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "zara",
    season: "winter",
    mrp: 3000,
    discount: 20,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 22,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20winter%20jackets/darkblue_jacket_pmkfz2.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "Tommy",
    season: "winter",
    mrp: 3500,
    discount: 10,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 23,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20winter%20jackets/black_jacket_wv1zfv.webp",
    gender: "women",
    name: "Full sleeve Jacket",
    brand: "Wildcraft",
    season: "winter",
    mrp: 1500,
    discount: 0,
    finalPrice: 0,
    rating:1,
  },
  {
    _id: uuid(),
    temp_id: 24,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20summer/white_tshirt_si06ym.webp",
    gender: "women",
    name: "women T-shirt",
    brand: "Rockhard",
    season: "summer",
    mrp: 2000,
    discount: 50,
    finalPrice: 0,
    rating:3,
  },
  {
    _id: uuid(),
    temp_id: 25,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20summer/nice_tshirt_ksudlr.webp",
    gender: "women",
    name: "women T-shirt",
    brand: "Polo",
    season: "summer",
    mrp: 3000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 26,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20summer/latest_top_iggun7.webp",
    gender: "women",
    name: "women T-shirt",
    brand: "Levis",
    season: "summer",
    mrp: 4000,
    discount: 50,
    finalPrice: 0,
    rating:4,
  },
  {
    _id: uuid(),
    temp_id: 27,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20summer/latest_tshirt_e9io2c.webp",
    gender: "women",
    name: "women T-shirt",
    brand: "Puma",
    season: "summer",
    mrp: 800,
    discount: 40,
    finalPrice: 0,
    rating:1,
  },
  {
    _id: uuid(),
    temp_id: 28,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513049/ecom%20item%20images/women%20summer/latest_suit_amnddz.webp",
    gender: "women",
    name: "women T-shirt",
    brand: "RedTape",
    season: "summer",
    mrp: 1500,
    discount: 30,
    finalPrice: 0,
    rating:2,
  },
  {
    _id: uuid(),
    temp_id: 29,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/women%20summer/great_tshirt_dqy9p2.webp",
    gender: "women",
    name: "women T-shirt",
    brand: "Urban Monkey",
    season: "summer",
    mrp: 500,
    discount: 20,
    finalPrice: 0,
    rating:1,
  },
  {
    _id: uuid(),
    temp_id: 30,
    image: "https://res.cloudinary.com/dbfzfqfhl/image/upload/v1647513048/ecom%20item%20images/women%20summer/black_suit_kb6vnw.webp",
    gender: "women",
    name: "women T-shirt",
    brand: "Being Human",
    season: "summer",
    mrp: 5000,
    discount: 10,
    finalPrice: 0,
    rating:4,
  },
];
